export default defineAppConfig({
  ui: {
    colors: {
      neutral: 'neutral'
    }
  }
})